import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import CommonHeadingNBtns from "../../common-components/CommonHeadingNBtns";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import SelectDropdown from "../../components-react/SelectDropdown";
import { regularPlansDropdown } from "../../common-data/DropdowData";

const PlanPauseForm = ({
  userInfoData,
  rowData,
  isEdit,
  closeModal,
  callFunction,
}) => {
  const dispatch = useDispatch();
  const { postPutLoading } = useSelector((state) => state.common);

  const initialFormValues = {
    selectedPlanDuration:
      isEdit && rowData?.plan_duration
        ? regularPlansDropdown.find(
            (item) => Number(item.value) === Number(rowData.plan_duration)
          )
        : "",
    pauseFrequency:
      isEdit && rowData?.pause_frequency ? rowData.pause_frequency : "",
    minDaysSpent:
      isEdit && rowData?.min_active_days_required
        ? rowData.min_active_days_required
        : "",
    minPauseDaysLeft:
      isEdit && rowData?.pause_buffer_days ? rowData.pause_buffer_days : "",
    maxPauseAllowed:
      isEdit && rowData?.max_days_per_pause ? rowData.max_days_per_pause : "",
    isAllAccess: isEdit && rowData?.has_all_access_pass ? true : false,
    isActive: isEdit && rowData?.status === "active" ? true : false,
  };
  const [formValues, setFormValues] = useState(initialFormValues);
  const [formErrors, setFormErrors] = useState({});

  const onChangeInput = (e) => {
    const { name, value, type, checked } = e.target;
    setFormValues((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const onChangeDropdown = (name, value) => {
    if (name === "selectedPlanDuration") {
      const planDurationValue = parseInt(value.value);
      const minDaysRequired = Math.floor(planDurationValue / 2);

      setFormValues({
        ...formValues,
        [name]: value,
        minPauseDaysLeft: minDaysRequired.toString(),
      });
    } else {
      setFormValues({ ...formValues, [name]: value });
    }
  };

  const validateForm = (values) => {
    const errors = {};

    if (!values.selectedPlanDuration) {
      errors.selectedPlanDuration = "Plan Duration is required!";
    }

    if (!values.pauseFrequency) {
      errors.pauseFrequency = "Pause Frequency is required!";
    }

    if (!values.minPauseDaysLeft) {
      errors.minPauseDaysLeft = "Minimum days required is required!";
    }

    if (!values.maxPauseAllowed) {
      errors.maxPauseAllowed = "Maximum pause allowed is required!";
    }

    if (
      values.selectedPlanDuration &&
      Number(values.minDaysSpent) >= Number(values.selectedPlanDuration.value)
    ) {
      errors.minDaysSpent = "Min Days Spent must be less than Plan Duration!";
    }

    return errors;
  };

  const handleSubmitForm = async (payload) => {
    const method = isEdit ? "PUT" : "POST";
    const endpoint = isEdit
      ? `/pause/update-pause-settings/${rowData.uid}`
      : "/pause/pause-settings";
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      // console.log("result?.payload", result?.payload);

      if (result?.payload?.status) {
        setFormValues(initialFormValues);
        callFunction();
        closeModal();
        toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const errors = validateForm(formValues);
    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      const userData = {
        plan_duration: Number(formValues.selectedPlanDuration?.value || 0),
        pause_frequency: Number(formValues.pauseFrequency || 0),
        min_active_days_required: Number(formValues.minDaysSpent || 0),
        max_days_per_pause: Number(formValues.maxPauseAllowed || 0),
        pause_buffer_days: Number(formValues.minPauseDaysLeft || 0),
        has_all_access_pass: formValues.isAllAccess ? true : false,
        status: formValues.isActive ? "active" : "inactive",
      };

      const handleConfirm = async () => {
        handleSubmitForm(userData);
      };

      showConfirmAlert(
        handleConfirm,
        `Are you sure!`,
        "Edit Form",
        "Submit Form"
      );
    }
  };

  return (
    <>
      <CommonHeadingNBtns
        title={`${isEdit ? "Update" : "Add"} Plan Pause`}
        btnTxt={isEdit ? "Update" : "Submit"}
        onClose={closeModal}
        onClick={onSubmit}
        isLoading={postPutLoading}
      />

      <form className="formContainer" onSubmit={onSubmit}>
        <div className="formInputsGrid twoGridSystem">
          <div className="formInputBox">
            <label htmlFor="selectedPlanDuration" className={`formInputLabel`}>
              Plan Duration <span className="required">*</span>
            </label>

            <div
              className={`commonWrapper ${
                formErrors.selectedPlanDuration ? "formError" : ""
              }`}>
              <SelectDropdown
                options={regularPlansDropdown}
                selectedOption={formValues.selectedPlanDuration}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown("selectedPlanDuration", selectedValue)
                }
                name="Plan Duration"
              />
            </div>
          </div>

          <div className="formInputBox">
            <label htmlFor="pauseFrequency" className="formInputLabel">
              Pause Limit <span className="required">*</span>
            </label>
            <input
              type="number"
              min="0"
              placeholder="Enter Pause Limit"
              className={`formInput ${
                formErrors.pauseFrequency ? "formError" : ""
              }`}
              name="pauseFrequency"
              value={formValues.pauseFrequency}
              onChange={onChangeInput}
            />
          </div>

          <div className="formInputBox">
            <label htmlFor="maxPauseAllowed" className="formInputLabel">
              Max pause days <span className="required">*</span>
            </label>
            <input
              type="number"
              min="0"
              placeholder="Enter Max pause days"
              className={`formInput ${
                formErrors.maxPauseAllowed ? "formError" : ""
              }`}
              name="maxPauseAllowed"
              value={formValues.maxPauseAllowed}
              onChange={onChangeInput}
            />
          </div>

          <div className="formInputBox">
            <label htmlFor="minDaysSpent" className="formInputLabel">
              Min Days Used
            </label>
            <input
              type="number"
              min="0"
              placeholder="Enter Min Days Used"
              className={`formInput ${
                formErrors.minDaysSpent ? "formError" : ""
              }`}
              name="minDaysSpent"
              value={formValues.minDaysSpent}
              onChange={onChangeInput}
            />
          </div>

          <div className="formInputBox span2">
            <label htmlFor="minPauseDaysLeft" className="formInputLabel">
              Min Days Left <span className="required">*</span>
            </label>
            <input
              type="number"
              min="0"
              placeholder="Enter Min Days Left"
              className={`formInput ${
                formErrors.minPauseDaysLeft ? "formError" : ""
              }`}
              name="minPauseDaysLeft"
              value={formValues.minPauseDaysLeft}
              onChange={onChangeInput}
            />
          </div>

          <div className="formInputBox checkbox-wrapper span2">
            <div className="flex-box">
              <label className="checkboxLabel">
                <input
                  type="checkbox"
                  name="isAllAccess"
                  checked={formValues.isAllAccess}
                  onChange={onChangeInput}
                />
                All Access Plan
              </label>

              <label className="checkboxLabel">
                <input
                  type="checkbox"
                  name="isActive"
                  checked={formValues.isActive}
                  onChange={onChangeInput}
                />
                Active
              </label>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default PlanPauseForm;
